/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page4_Warning_SerialInputs */



/**
* | output |
* | --- |
* | "Refer primarily to SERIAL characters, not the index" |
*
* @param {Intervention_Plan_Pdf_Page4_Warning_SerialInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page4_warning_serial = /** @type {((inputs?: Intervention_Plan_Pdf_Page4_Warning_SerialInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page4_Warning_SerialInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Refer primarily to SERIAL characters, not the index")
	return /** @type {LocalizedString} */ ("Referez-vous en priorité aux caracteres SERIAL et non à l'index")
});